/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import { NON_RKPAY_INVOICE_COLUMNS, NON_RKPAY_INVOICE_TYPE } from "@constants";
import PropTypes from "prop-types";
import utils from "@utils";
import { ScrollDetect } from "../../../../components";

const PaidTable = ({
	activeType,
	updateSort,
	selectAllRecords,
	multipleSelection,
	filters,
	records,
	onEditInvoice,
	selectedRecords,
	updateSelectedRecord,
	user,
	showMultipleOfficerModal,
	onViewReceiptHandler,
	hasMoreRecords,
	loadNextPage,
}) => {
	const { lang } = global;

	return (
		<>
			<div className="row hidden-xs hidden-sm hidden-md invoice-columns">
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber);
					}}
				>
					<If condition={multipleSelection}>
						<label
							htmlFor="checkbox_all"
							className="selector-label margin-right-12"
						>
							<input
								type="checkbox"
								id="checkbox_all"
								name="selectAllItems"
								onChange={() => selectAllRecords()}
								onClick={e => e.stopPropagation()}
								aria-label="Select All Items"
								disabled
							/>
						</label>
					</If>
					<span className="font-semi-bold">
						{lang.t(
							activeType === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key
								? "Estimate"
								: "Invoice",
						)}{" "}
						#
					</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.InvoiceNumber}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2"
					role="button"
					tabIndex="0"
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.ClientName);
					}}
				>
					<span className="font-semi-bold">{lang.t("Client")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.ClientName}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div className="col-md-2 col-lg-2">
					<span className="font-semi-bold">{lang.t("Officer")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Officer}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				{/** Use StartDateTime as sort field, there is no JobDateRange field in endpoint, we build that with StartDateTime and EndDateTime */}
				<div
					className="col-md-2 col-lg-1 date-range-column"
					role="button"
					tabIndex="0"
				>
					<span className="font-semi-bold">{lang.t("Job Date")}</span>
				</div>
				<div
					className="col-md-1 col-lg-1"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.SentDate)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.SentDate);
					}}
				>
					<span className="font-semi-bold">{lang.t("Sent Date")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.SentDate}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-1 col-lg-1 text-right"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.Total)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.Total);
					}}
				>
					<span className="font-semi-bold">{lang.t("Total")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Total}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div
					className="col-md-2 col-lg-2 text-right"
					role="button"
					tabIndex={0}
					onClick={() => updateSort(NON_RKPAY_INVOICE_COLUMNS.Balance)}
					onKeyPress={({ key }) => {
						if (key === "Enter") updateSort(NON_RKPAY_INVOICE_COLUMNS.Balance);
					}}
				>
					<span className="font-semi-bold">{lang.t("Balance Due")}</span>
					<If condition={filters.sortBy === NON_RKPAY_INVOICE_COLUMNS.Balance}>
						<i
							className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
						/>
					</If>
				</div>
				<div className="col-md-2 col-lg-2 text-right hidden-xs hidden-md" />
			</div>
			<div
				className="hidden-xs hidden-sm hidden-md invoice-columns-body"
				style={{ paddingTop: "20px", paddingBottom: "20px" }}
			>
				{records.length > 0 &&
					records.map(item => {
						const sameJobDay = utils.datesAreOnSameDay(
							new Date(item.StartDateTime),
							new Date(item.EndDateTime),
						);

						return (
							<div
								style={{ paddingBottom: "30px" }}
								key={`${item.Id}-${item.InvoiceNumber}`}
								className="row"
								role="button"
								onClick={onEditInvoice(item.Id)}
								tabIndex={0}
							>
								<div className="col-md-2 col-lg-2 truncate">
									<If condition={multipleSelection}>
										<label
											htmlFor={`check_${item.Id}`}
											className="selector-label margin-right-12"
										>
											<input
												type="checkbox"
												id={`check_${item.Id}`}
												name="selectItem"
												checked={selectedRecords[item.Id]}
												onChange={() => updateSelectedRecord(item)}
												onClick={e => e.stopPropagation()}
												aria-label="Select Item"
												disabled
											/>
										</label>
									</If>
									<span>{item.InvoiceNumber}</span>
								</div>
								<div
									className="col-md-2 col-lg-2 truncate"
									title={item.ClientName}
								>
									<span>{item.ClientName}</span>
								</div>
								<div
									className="col-md-2 col-lg-2 truncate"
									title={
										item.OfficerNames.length > 1
											? lang.t("Multiple Officers")
											: item.OfficerNames[0]
									}
								>
									<If condition={item.OfficerNames.length > 1}>
										<button
											id={`multiple-officer-button-${item.Id}`}
											type="button"
											className="btn btn-link btn-officers"
											onClick={event => {
												event?.stopPropagation();
												showMultipleOfficerModal(item.Id);
											}}
										>
											{lang.t("Multiple Officers")}
										</button>
									</If>
									<If condition={item.OfficerNames.length <= 1}>
										<span>{item.OfficerNames[0]}</span>
									</If>
								</div>
								<div
									className={`${
										activeType === NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key
											? "col-md-3 col-lg-1 date-range-column"
											: "col-md-2 col-lg-1 date-range-column"
									}`}
								>
									<span>
										{sameJobDay
											? utils.formatDate(
													item.StartDateTime,
													"en-US",
													user.TimeZoneId,
													"numeric",
												)
											: `${utils.formatDate(item.StartDateTime, "en-US", user.TimeZoneId, "numeric")} - ${utils.formatDate(item.EndDateTime, "en-US", user.TimeZoneId, "numeric")}`}
									</span>
								</div>
								<div className="col-md-1 col-lg-1">
									<span>
										{item.SentDate == null
											? ""
											: utils.formatDate(
													item.SentDate,
													"en-US",
													user.TimeZoneId,
													"numeric",
												)}
									</span>
								</div>
								<div className="col-md-1 col-lg-1 text-right">
									<span className="font-semi-bold">
										{utils.currencyFormatter(item.GrandTotal)}
									</span>
									<If
										condition={
											item.PaymentStatus !== null &&
											item.PaymentStatus === "Pending"
										}
									>
										<div>
											<span
												className="badge badge-warning"
												style={{
													backgroundColor: "#FBD86C",
													color: "#202939",
													borderRadius: "4px",
												}}
											>
												{lang.t("Processing")}
											</span>
										</div>
									</If>
								</div>
								<div className="col-md-2 col-lg-2 text-right">
									<span className="font-semi-bold">
										{utils.currencyFormatter(utils.bankersRound(item.Balance))}
									</span>
								</div>
								<div className="col-md-12 col-lg-1 actions-column">
									<button
										type="button"
										className="btn btn-sm btn-primary grow"
										onClick={ev => onViewReceiptHandler(ev, item)}
									>
										{lang.t("View receipt")}
									</button>

								</div>
							</div>
						);
					})}
			</div>
			<div className="hidden-lg">
				{records.length > 0 &&
					records.map(item => {
						const sameJobDay = utils.datesAreOnSameDay(
							new Date(item.StartDateTime),
							new Date(item.EndDateTime),
						);
						return (
							<div key={`${item.Id}-${item.InvoiceNumber}`} className="row">
								<div className="invoice-card">
									<If
										condition={
											item.PaymentStatus !== null &&
											item.PaymentStatus === "Pending"
										}
									>
										<div className="card-item">
											<span
												className="badge badge-warning"
												style={{
													marginLeft: "20px",
													backgroundColor: "#FBD86C",
													color: "#202939",
													borderRadius: "4px",
												}}
											>
												{lang.t("Processing")}
											</span>
										</div>
									</If>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t(
												activeType === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key
													? "Estimate"
													: "Invoice",
											)}{" "}
											#:&nbsp;
										</span>
										<button
											className="btn btn-link"
											type="button"
											onClick={onEditInvoice(item.Id)}
										>
											{item.InvoiceNumber}
										</button>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Client")}:&nbsp;
										</span>
										<span>{item.ClientName}</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Officer")}:&nbsp;
										</span>
										<If condition={item.OfficerNames.length > 1}>
											<button
												type="button"
												className="btn btn-link btn-officers"
												onClick={() => showMultipleOfficerModal(item.Id)}
											>
												{lang.t("Multiple Officers")}
											</button>
										</If>
										<If condition={item.OfficerNames.length <= 1}>
											<span>{item.OfficerNames[0]}</span>
										</If>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Job Date")}:&nbsp;
										</span>
										<span>
											{sameJobDay
												? utils.formatDate(
														item.StartDateTime,
														"en-US",
														user.TimeZoneId,
														"numeric",
													)
												: `${utils.formatDate(item.StartDateTime, "en-US", user.TimeZoneId, "numeric")} - ${utils.formatDate(item.EndDateTime, "en-US", user.TimeZoneId, "numeric")}`}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Sent Date")}:&nbsp;
										</span>
										<span>
											{item.SentDate == null
												? ""
												: utils.formatDate(
														item.SentDate,
														"en-US",
														user.TimeZoneId,
														"numeric",
													)}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t("Total")}:&nbsp;
										</span>
										<span>
											{utils.currencyFormatter(
												utils.bankersRound(item.GrandTotal),
											)}
										</span>
									</div>
									<div className="card-item">
										<span className="font-semi-bold">
											{lang.t(
												activeType ===
													NON_RKPAY_INVOICE_TYPE.ESTIMATES.key ||
													activeType === NON_RKPAY_INVOICE_TYPE.PAID.key
													? "Balance"
													: "Balance Due",
											)}
											:&nbsp;
										</span>
										<span>
											{utils.currencyFormatter(
												utils.bankersRound(item.Balance),
											)}
										</span>
									</div>
									<div className="actions">
										<button
											type="button"
											className="btn btn-sm btn-primary grow"
											onClick={ev => onViewReceiptHandler(ev, item)}
										>
											{lang.t("View receipt")}
										</button>
									</div>
								</div>
							</div>
						);
					})}
			</div>
			<If condition={hasMoreRecords}>
				<ScrollDetect
					className="text-center"
					onVisible={() => loadNextPage()}
				>
					<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
				</ScrollDetect>
			</If>
		</>
	);
};

PaidTable.propTypes = {
	activeType: PropTypes.string,
	updateSort: PropTypes.func,
	selectAllRecords: PropTypes.func,
	multipleSelection: PropTypes.bool,
	filters: PropTypes.object,
	records: PropTypes.array,
	onEditInvoice: PropTypes.func,
	selectedRecords: PropTypes.object,
	updateSelectedRecord: PropTypes.func,
	user: PropTypes.object,
	showMultipleOfficerModal: PropTypes.func,
	onViewReceiptHandler: PropTypes.func,
	hasMoreRecords: PropTypes.bool,
	loadNextPage: PropTypes.func,
};

export default PaidTable;
